.wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 20px;
  border-bottom: 1px solid var(--ed-border, #ece5d8);

  img {
    width: 32px;
    min-width: 32px;
    border-radius: 8px;
    overflow: hidden;
  }

  p {
    color: #231e19;
    text-align: center;
    font-size: 15px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0.045px;
  }
}

.wrapperV2 {
  width: 100%;
  height: 48px;
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-bottom: 1px solid var(--ed-border, #ece5d8);

  .logoV2 {
    width: 205.45px;
    height: 26.45px;
    min-width: 205.45px;
    min-height: 26.45px;
    display: block;
    background-image: url('./img/logoV2.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
  }
}

// Dark mode
:global body.dark {
  :local {
    .wrapper {
      border-bottom: 1px solid var(--ed-border, #2a2928);

      p {
        color: #fffbf2;
      }
    }
  }
}
